import React from 'react';
import { camelCase, capitalize } from 'lodash';
import { translate } from '@fiverr-private/i18n-react';
import { ColumnDef } from '@fiverr-private/briefs_table';
import { BriefStatusTag } from '@fiverr-private/dynamic_matching';
import { getUserName } from '../../../lib/utils/getters';
import { appTranslate } from '../../i18n';
import { BriefItem } from '../../../lib/types/brief';
import { Title } from './cells/Title';
import { Summary } from './cells/Summary';
import { Action } from './cells/Action';
import { Mobile } from './cells/Mobile';
import { Middle } from './cells/Middle';
import {
  middleVisibility,
  mobileVisibility,
  nonVisibleOnMiddle,
  nonVisibleOnMobile,
  onlyPaddingRight,
  summaryVisibility,
} from './styles.ve.css';
import { More } from './cells/More';

export const useColumns = (openSuccessModal: () => void): ColumnDef<BriefItem, any>[] => [
  {
    id: 'title',
    accessorFn: (brief) => getUserName(brief.createdBy),
    cell: ({ row }) => <Title row={row} />,
    header: appTranslate('table.brief_title').toUpperCase(),
    meta: {
      className: nonVisibleOnMiddle,
    },
  },
  {
    id: 'middle',
    cell: ({ row }) => <Middle row={row} />,
    header: appTranslate('table.brief_title').toUpperCase(),
    meta: {
      className: middleVisibility,
    },
  },
  {
    id: 'status',
    header: appTranslate('table.status').toUpperCase(),
    accessorFn: (brief) => capitalize(translate<string>(`statuses.${camelCase(brief.briefDisplayStatus)}`)),
    cell: ({ row }) => <BriefStatusTag status={row.original.briefDisplayStatus} />,
    meta: {
      className: nonVisibleOnMiddle,
    },
  },
  {
    id: 'summary',
    cell: ({ row }) => <Summary row={row} />,
    header: appTranslate('table.summary').toUpperCase(),
    meta: {
      className: summaryVisibility,
    },
  },
  {
    id: 'action',
    cell: ({ row }) => <Action row={row} />,
    header: appTranslate('table.action').toUpperCase(),
    meta: {
      align: 'end',
      className: nonVisibleOnMobile,
    },
  },
  {
    id: 'more',
    cell: ({ row }) => <More row={row} openSuccessModal={openSuccessModal} />,
    meta: {
      align: 'end',
      className: `${nonVisibleOnMobile} ${onlyPaddingRight}`,
    },
  },
  {
    id: 'mobile',
    cell: ({ row }) => <Mobile row={row} openSuccessModal={openSuccessModal} />,
    header: appTranslate('table.brief_title').toUpperCase(),
    meta: {
      className: mobileVisibility,
    },
  },
];
